import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../hooks/useScale';
import { useColors } from '../../hooks/useColors';
import theme from '../../common/theme';

const OtherItemsModalStyles = () => {
  const { colors } = useColors();
  const { scale } = useScale();

  return useMemo(
    () =>
      StyleSheet.create({
        containerFullWidth: {
          width: '100%',
        },
        itemRow: {
          flexDirection: 'row',
          alignItems: 'flex-start',
          paddingVertical: scale(4),
        },
        note: {
          letterSpacing: -0.2,
          fontSize: scale(14),
          lineHeight: scale(20),
          marginBottom: scale(4),
          color: colors.noteText,
          fontVariant: ['tabular-nums'],
        },
        allergenBanner: {
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: scale(8),
          marginBottom: scale(8),
          paddingVertical: scale(6),
          paddingHorizontal: scale(6),
          borderRadius: scale(4),
          backgroundColor: colors.allergenBannerView,
        },
        allergenBannerText: {
          fontSize: scale(14),
          lineHeight: scale(20),
          fontFamily: theme.fonts.semibold,
          color: colors.allergenBannerText,
        },
        allergenItemLabel: {
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: scale(8),
          marginBottom: scale(4),
          paddingVertical: scale(9),
          paddingLeft: scale(6),
          borderRadius: scale(4),
          backgroundColor: colors.allergenItemView,
        },
        allergenItemLabelText: {
          flex: 1,
          fontSize: scale(14),
          lineHeight: scale(20),
          fontFamily: theme.fonts.semibold,
          color: colors.allergenItemText,
        },
        allergenItemLabelSeat: {
          lineHeight: scale(22),
          fontFamily: theme.fonts.medium,
          fontVariant: ['tabular-nums'],
          color: colors.allergenItemSeat,
        },
        allergenItemIconSpacer: {
          width: scale(40),
          // Cancels the row's columnGap so the seat lands on the same right
          // edge as the item row's, which has no gap before its icon.
          marginLeft: -scale(8),
        },
        profileRow: {
          alignItems: 'center',
          rowGap: 4,
        },
        itemQuantity: {
          minWidth: scale(30),
          height: scale(32),
          marginTop: scale(2),
          marginRight: scale(12),
          paddingHorizontal: scale(4),
          borderRadius: theme.radius.s,
          backgroundColor: colors.qtyView,
          justifyContent: 'center',
          alignItems: 'center',
          fontVariant: ['tabular-nums'],
        },
        qtyText: {
          fontSize: scale(16),
          color: colors.text,
          textAlign: 'center',
          fontFamily: theme.fonts.medium,
          lineHeight: scale(14),
        },
        itemDetails: {
          flex: 1,
          flexDirection: 'column',
        },
        itemName: {
          fontSize: scale(16),
          color: colors.text,
          fontFamily: theme.fonts.medium,
          lineHeight: scale(20),
          fontVariant: ['tabular-nums'],
        },
        printerProfileName: {
          fontSize: scale(14),
          color: colors.text,
          fontFamily: theme.fonts.medium,
          fontVariant: ['tabular-nums'],
          lineHeight: scale(20),
        },
        modifierName: {
          fontSize: scale(16),
          color: colors.text,
          opacity: 0.6,
          marginTop: 0,
          lineHeight: scale(22),
          fontFamily: theme.fonts.regular,
          fontVariant: ['tabular-nums'],
        },
        rightContainer: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginLeft: 'auto',
          gap: scale(8),
          minWidth: scale(60),
        },
        // Section divider for Other Items
        sectionDivider: {
          backgroundColor: colors.elevation2,
          paddingHorizontal: scale(14),
          paddingVertical: scale(8),
          borderRadius: theme.radius.s,
        },
        rowText: {
          fontSize: scale(14),
          color: colors.text,
          textAlign: 'center',
          fontFamily: theme.fonts.medium,
          fontVariant: ['tabular-nums'],
          lineHeight: scale(20),
        },
        iconContainer: {
          marginLeft: scale(8),
          alignItems: 'center',
          justifyContent: 'center',
        },
        notifierContainer: {
          rowGap: scale(16),
          marginTop: scale(16),
        },
        courseNameRow: {
          flexDirection: 'row',
          alignItems: 'center',
        },
        completedBadge: {
          marginLeft: scale(8),
          paddingVertical: scale(2),
          paddingHorizontal: scale(8),
          borderRadius: theme.radius.s,
          borderWidth: 1,
          borderColor: colors.green,
          backgroundColor: colors.greenLight,
        },
        completedLabel: {
          fontSize: scale(12),
          color: colors.green,
          fontFamily: theme.fonts.semibold,
          textTransform: 'uppercase',
        },
      }),
    [colors, scale],
  );
};

export default OtherItemsModalStyles;
